// Import the functions you need from the SDKs you need
import { appConfig } from "../enviroments/enviroment";
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import {
  initializeAppCheck,
  getToken,
  ReCaptchaEnterpriseProvider,
} from "firebase/app-check";
let firebaseAuth;

// Initialize Firebase
export const app = initializeApp(appConfig.firebaseConfig);

export const loadFirebaseAuth = () => {
  if (firebaseAuth) {
    return firebaseAuth;
  } else {
    firebaseAuth = getAuth();
    return firebaseAuth;
  }
};

export const appCheck = initializeAppCheck(app, {
  provider: new ReCaptchaEnterpriseProvider(appConfig.appCheckKey),

  isTokenAutoRefreshEnabled: true,
});

export async function fetchAppCheckToken() {
  try {
    const tokenResponse = await getToken(appCheck, /* forceRefresh= */ true);
    return tokenResponse.token;
  } catch (error) {
    return null;
  }
}
